module.exports = __webpack_public_path__ + "static/select-devtools-80dd2c9b7b91db6990f03814a502a9bd.png";